import api from '@/api/services/api'

const add = data => api({
  method: 'post',
  url: 'favorites',
  data
})

const remove = params => api({
  method: 'delete',
  url: 'favorites',
  params
})

const removeAll = () => api({
  method: 'delete',
  url: 'favorites/all',
})

const getCollection = params => api({
  method: 'get',
  url: 'favorites',
  params
})

const refreshPrice = id => api({
  method: 'get',
  url: `favorites/${id}/refresh`
})

export {
  add,
  remove,
  removeAll,
  getCollection,
  refreshPrice
}